module.exports = __webpack_public_path__ + "static/media/Screenshot6.75769c88.png";